<style scoped>
.social-button {
  width: 75px;
  background: white;
  padding: 10px;
  border-radius: 100%;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  outline: 0;
  border: 0;
  margin: 0px;
}
.social-button:active {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
}
</style>
<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-text-field v-model="username" label="Username" required></v-text-field>

    <v-text-field
      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
      :type="showPassword ? 'text' : 'password'"
      name="input-10-2"
      label="Password"
      v-model="password"
      class="input-group--focused"
      @click:append="showPassword = !showPassword"
      v-on:keyup.enter="onPasswordEnterKeyup($event)"
    ></v-text-field>

    <v-alert outlined type="error" v-if="isFailMessageActive && error">
      {{ error.details }}
    </v-alert>

    <div class="d-flex justify-start">
      <v-btn :disabled="false" color="primary" class="mr-4" @click="onLogin">
        Login
      </v-btn>
      <v-btn v-if="aadEnabled" class="social-button" @click="onPetersonLogin">
        <v-img
          :src="require('@/assets/peterson-logo.png')"
          alt="Peterson Logo"
          max-width="60"
        ></v-img>
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    valid: true,
    username: null,
    select: null,
    showPassword: false,
    password: null,
    isLoading: false,
    isFullPageLoading: false,
    failedToLoginMessage: 'Invalid username or password',
    isFailMessageActive: false,
    error: null,
  }),
  computed: {
    ...mapGetters({
      aadEnabled: 'userStore/aadEnabled',
    }),
    loginEnabled() {
      return (this.password.length > 1)
        && (this.username.length > 1);
    },
  },
  methods: {
    onLogin() {
      this.$toast('Logging in...');
      this.isLoading = true;
      this.isFailMessageActive = false;
      this.$store.dispatch('userStore/login', { username: this.username, password: this.password })
        .catch((error) => {
          this.error = error;
          this.isLoading = false;
          this.isFailMessageActive = true;
        });
    },
    onPetersonLogin() {
      window.location.replace('/AzureAD/Account/SignIn');
    },
    onPasswordEnterKeyup(event) {
      this.onLogin();
    },
    onSuccess(message, data) {
      this.$toast.success(message);
    },
    onError(message, data) {
      this.$toast.error(message);
    },
  },
};
</script>
